var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChevronsUp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6087 9.60869C14.3646 9.85277 13.9689 9.85277 13.7248 9.60869L10.0001 5.88396L6.27536 9.60869C6.03128 9.85277 5.63555 9.85277 5.39147 9.60869C5.1474 9.36461 5.1474 8.96888 5.39147 8.72481L9.26351 4.85277C9.67031 4.44597 10.3299 4.44597 10.7367 4.85277L14.6087 8.72481C14.8528 8.96888 14.8528 9.36461 14.6087 9.60869Z",
    fill: "#5DA196"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6087 14.6087C14.3646 14.8528 13.9689 14.8528 13.7248 14.6087L10.0001 10.884L6.27536 14.6087C6.03128 14.8528 5.63555 14.8528 5.39147 14.6087C5.1474 14.3646 5.1474 13.9689 5.39147 13.7248L9.26351 9.85277C9.67031 9.44597 10.3299 9.44597 10.7367 9.85277L14.6087 13.7248C14.8528 13.9689 14.8528 14.3646 14.6087 14.6087Z",
    fill: "#5DA196"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronsUp);
export default __webpack_public_path__ + "static/media/chevrons-up.c7fa2a6fb73074680be5fbad317dc998.svg";
export { ForwardRef as ReactComponent };